var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.agency)?_c('main',{staticClass:"app-content"},[_c('aside',{staticClass:"fixed-sidebar"},[_c('side-bar',{attrs:{"agency":_vm.agency}})],1),_c('campaigns',{attrs:{"agency":_vm.agency}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }